import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9dfc1328"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ShopWindowCategoryBar" }
const _hoisted_2 = ["onClick"]

import { reactive } from 'vue'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: {
  list: {
    type: Array as () => Array<any>,
    default: () => []
  },
  // 当前选中的下标
  curIndex: {
    type: Number,
    default: 0
  },
  // 最多显示多少item
  size: {
    type: Number,
    default: 10
  },
  labelKey: {
    type: String,
    default: 'shopType'
  }
},
  emits: ['update:selected'],
  setup(__props, { emit: emits }) {

const props = __props




const data: any = reactive({
  // 列表
  list: []
})

// 选中
const selected = (index: number) => {
  emits('update:selected', index)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list.slice(0, __props.size), (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["ShopWindowCategoryBar-item", { active: __props.curIndex === i }]),
        key: item.id,
        onClick: ($event: any) => (selected(i))
      }, _toDisplayString(_unref(t)(item.shopType)), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})